
import { mapState, mapActions, mapGetters } from "vuex";
import InvalidFormatDialog from "../dialogs/menu-upload-info-dialog.vue";
import MenuAddItemComboDialog from "../dialogs/menu-add-item-combo-dialog.vue";
import PackagingChargeSlabDialog from "../dialogs/packaging-charge-slab-dialog.vue";
import MenuPhotoUploader from "./menu-photo-uploader.vue";
const COMBO_ITEM = "Zomato::Item",
  COMBO_ITEM_VARIANT = "Zomato::ItemVariant";
export default {
  components: {
    InvalidFormatDialog,
    PackagingChargeSlabDialog,
    MenuAddItemComboDialog,
    MenuPhotoUploader
  },
  props: {
    comboId: {
      default: ""
    }
  },
  computed: {
    ...mapState("menu", ["menuItems", "taxes"]),
    ...mapGetters("restaurant", [
      "hasMultipleBrands",
      "getAllBrands",
      "getLocationChannels"
    ]),

    isNew() {
      return !this.comboId || this.comboId === "new";
    },
    defaultTaxes() {
      const taxes = this.taxes.filter(
        (tax) => tax.tax_name == "CGST@2.5" || tax.tax_name == "SGST@2.5"
      );
      return taxes && taxes.length ? taxes.map((tax) => tax.id) : [];
    },

    notValid() {
      return (
        !this.valid || this.combo.packaging_charge > this.getMaxPackagingCharge
      );
    },
    menuItemList() {
      return this.hasMultipleBrands
        ? this.menuItems.filter((el) =>
            el.restaurant_ids?.some((id) => id === this.selectedBrand)
          )
        : this.menuItems;
    },
    getMaxPackagingCharge() {
      if (!this.combo) {
        return;
      } else {
        let price = this.combo.amount;
        const applicableSlab =
          this.$constants.PackagingSlabs.PACKAGING_SLABS.find(
            (slab) => price <= slab.max
          );
        return applicableSlab.maxCharge;
      }
    }
  },

  data() {
    return {
      combo: {
        name: "",
        description: "",
        amount: null,
        image: null,
        tax_ids: [],
        channels: [],
        packaging_charge: null,
        combo_items_attributes: []
      },
      comboItems: [],
      valid: false,
      selectRuleForVariants: [(v) => !!v || "Item is required"],
      NEW_COMBO_ITEM: {
        item: {},
        quantity: 0,
        selectedVariant: null
      },
      saveLoading: false,
      selectedBrand: null,
      characterLimitRule: [(v) => v?.length <= 70 || "Max 70 characters"],
      taxRules: [(v) => (!!v && v.length > 0) || "Tax is required"],
      descriptionRule: [
        (v) => !!v.trim() || "Description is required",
        (v) =>
          !this.combo.description ||
          v.trim().toLowerCase() !== this.combo.name.trim().toLowerCase() ||
          "Combo Name cannot be the same as  Description",
        (v) =>
          !v ||
          v.trim().length >= 10 ||
          "Description requires at least 10 characters"
      ],

      photo: null,
      cropImg: null,
      showPackagingChargeSlab: false,
      showMinimumComboRequiredWarning: false,
      showAddItemComboDialog: false,
      showWarningDialog: false,
      dialogContent: "",
      dialogTitle: ""
    };
  },
  beforeMount() {
    this.getTaxes();
    if (!this.hasMultipleBrands) {
      this.selectedBrand = this.getAllBrands[0]?.id;
    } else {
      this.selectedBrand = null;
    }
    if (!this.isNew) {
      this.initItem();
    }
  },
  mounted() {
    if (this.isNew) {
      this.initNewItem();
    }
  },
  watch: {
    taxes() {
      if (this.isNew) this.initNewItem();
    },
    "combo.name"(newVal) {
      if (this.$refs.description) {
        this.$refs.description.validate();
      }
    }
  },
  methods: {
    ...mapActions("menu", [
      "getCombosDetail",
      "createCombo",
      "uploadImage",
      "updateCombo",
      "getCombosList",
      "getTaxes"
    ]),
    handleComboItemSubmission(selectedItems) {
      this.comboItems = selectedItems;
    },
    toggleItemOptions(index) {
      const clonedItems = JSON.parse(JSON.stringify(this.comboItems));
      clonedItems[index].showOptions = !clonedItems[index].showOptions;
      this.comboItems = clonedItems;
    },
    handleCroppedPhoto({ cropImg, photo }) {
      this.cropImg = cropImg;
      this.photo = photo;
      if (!this.photo) {
        this.combo.image_url = null;
      }
    },
    handleComboVariantSelection(val, index) {
      this.comboItems[index] = {
        ...this.comboItems[index],
        selectedVariant: val,
        quantity: 1
      };
      this.comboItems = JSON.parse(JSON.stringify(this.comboItems));
    },
    updateQty(index, increment) {
      const qty = Number(this.comboItems[index].quantity);
      this.comboItems[index].quantity = increment ? qty + 1 : qty - 1;
      if (!this.comboItems[index].quantity) {
        this.deleteItem(index);
      } else {
        this.comboItems = JSON.parse(JSON.stringify(this.comboItems));
      }
    },
    handleUpdateQuantity({ index, increment }) {
      this.updateQty(index, increment);
    },
    handleCheckboxSelection(index, isSelected) {
      this.comboItems[index].quantity = isSelected ? 1 : 0;
      if (!this.comboItems[index].quantity) {
        this.deleteItem(index);
      } else {
        this.comboItems = JSON.parse(JSON.stringify(this.comboItems));
      }
    },
    initNewItem() {
      this.combo.tax_ids = this.defaultTaxes;
      this.combo.channels = this.getLocationChannels.map((el) => {
        return el.name;
      });
    },
    async initItem() {
      const $this = this;
      try {
        const { data } = await this.getCombosDetail(this.comboId);
        this.combo = JSON.parse(JSON.stringify(data));
        this.comboItems = [...data.combo_items];
        this.selectedBrand = data.restaurant_id;
        this.comboItems.forEach((el, index) => {
          if (el.comboable_type == COMBO_ITEM) {
            this.comboItems[index] = {
              ...this.menuItems.find((item) => item.id == el.comboable_id),
              ...el
            };
          } else if (el.comboable_type == COMBO_ITEM_VARIANT) {
            const menuItem = $this.menuItems.find(
              (item) =>
                item?.variants?.items?.length &&
                item?.variants?.items?.find((variant) => {
                  return variant.id == el.comboable_id;
                })
            );
            $this.comboItems[index] = {
              ...menuItem,
              ...el,
              comboable_id: menuItem.id,
              selectedVariant: el.comboable_id
            };
          }
        });
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
        console.log(error);
      }
    },
    deleteItem(index) {
      this.comboItems.splice(index, 1);
    },
    validateForm() {
      this.valid = this.$refs.comboForm.validate();
    },
    async handleUploadImage() {
      const croppedFile = await this.dataUrlToFile(
        this.cropImg,
        this.photo.name || "untitled"
      );
      if (croppedFile) {
        let formData = new FormData();
        formData.append("item_image", croppedFile);
        formData.append(
          "transformation",
          JSON.stringify([
            { height: 400, width: 400, crop: "fill", gravity: "auto" }
          ])
        );
        try {
          const { data } = await this.uploadImage(formData);
          if (data.status === "success") {
            return data?.data;
          } else {
            this.$nuxt.$emit("show-error-toast", data.message);
            return false;
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        return false;
      }
    },
    async handleSubmit() {
      this.validateForm();
      if (this.comboItems.length < 2) {
        this.showMinimumComboRequiredWarning = true;
        return;
      } else {
        this.showMinimumComboRequiredWarning = false;
      }
      if (this.valid) {
        this.saveLoading = true;

        if (this.photo) {
          const imgUrl = await this.handleUploadImage();
          if (imgUrl) {
            this.combo.image_url = imgUrl;
          } else {
            this.photo = null;
            this.cropImg = null;
            this.saveLoading = false;
            return;
          }
        }
        if (this.isNew) {
          this.handleCreateCombo();
        } else {
          this.handleUpdateCombo();
        }
      }
    },

    getComboPayload() {
      let payload = JSON.parse(JSON.stringify(this.combo));
      payload.combo_items_attributes = this.comboItems.map((el) => {
        const data = {
          comboable_type: el.selectedVariant ? COMBO_ITEM_VARIANT : COMBO_ITEM,
          quantity: el.quantity
        };
        if (el.comboable_id) {
          data.comboable_id = el.selectedVariant || el.comboable_id;
        } else {
          data.comboable_id = el.selectedVariant || el.id;
        }
        return data;
      });
      delete payload.combo_items;
      payload.restaurant_id = this.selectedBrand;
      payload.packaging_charge = Number(payload.packaging_charge);
      payload.amount = Number(payload.amount);
      return payload;
    },
    resetFields() {
      this.combo = {
        name: "",
        description: "",
        amount: null,
        image: null,
        tax_ids: [],
        channels: [],
        packaging_charge: null,
        combo_items_attributes: []
      };
      this.comboItems = [];
      this.$refs.comboForm.reset();
      this.valid = false;
      this.photo = null;
      this.initNewItem();
    },
    async handleCreateCombo() {
      try {
        await this.createCombo(this.getComboPayload());
        this.$nuxt.$emit("show-toast", {
          text: "Combo created successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
        this.getCombosList(true);
        // this.resetFields();
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
      this.saveLoading = false;
    },
    async handleUpdateCombo() {
      try {
        await this.updateCombo({
          payload: this.getComboPayload(),
          comboId: this.comboId
        });
        this.$nuxt.$emit("show-toast", {
          text: "Combo updated successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
        this.getCombosList(true);
        this.$emit("close-dialog");
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
      this.saveLoading = false;
    }
  }
};
